<section [class.highlighted]="planState === 'NEW_PLAN'" class="plan-brief-table-wrapper">
  <header class="header" translate>
    PLANS.{{planState}}
  </header>

  <div class="info-row plan-name-price">
    <span class="info-row-title">{{planName}}</span>
    <div class="info-row-value">
      <span class="price">${{getPriceLabel()}}</span>
    </div>
  </div>


  <div class="info-row">
    <span class="info-row-title" translate>PLANS.USERS</span>
    <div class="info-row-value">{{numberOfUsers}}</div>
  </div>


  <div class="info-row">
    <span class="info-row-title" translate>PLANS.BILLING_PERIOD</span>
    <div class="info-row-value" translate>{{billingPeriodKey}}</div>
  </div>

</section>
